import { useNavigate } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';

export default function BotonVolver({ text, targetId = 'productos' }) {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate('/');
    setTimeout(() => {
      const element = document.getElementById(targetId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 500);
  };

  return (
    <div className="fixed top-6 left-6 z-50">
      <button 
        className="group flex items-center gap-2 px-5 py-2.5 bg-zinc-900/80 backdrop-blur-md border border-zinc-800 text-zinc-300 hover:text-white rounded-full transition-all duration-300 hover:border-zinc-700 shadow-xl"
        onClick={handleGoBack}
      >
        <ChevronLeft className="w-5 h-5 transition-transform group-hover:-translate-x-1" />
        <span className="text-sm font-medium tracking-wide uppercase">{text}</span>
      </button>
    </div>
  );
}
